import { IconButton, useTheme } from "@material-ui/core";
import { IconArrowLeft } from "@tabler/icons-react";
import { useHistory } from "react-router-dom";

interface props {
  onClick?: () => void;
  size?: "small" | "medium";
}
const GoBackIconButton = ({ onClick, size }: props) => {
  const history = useHistory();

  const handleBack = () => {
    history.goBack();
    if (onClick) {
      onClick();
    }
  };

  const theme = useTheme();

  return (
    <IconButton size={size} onClick={handleBack}>
      <IconArrowLeft color={theme.palette.primary.main} />
    </IconButton>
  );
};

export default GoBackIconButton;
